"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = formatPrice;
exports.formatDateInterval = formatDateInterval;
Object.defineProperty(exports, "formatDuration", {
  enumerable: true,
  get: function get() {
    return _duration.formatDuration;
  }
});

var _duration = require("duration");

function formatPrice(value) {
  var alwaysIncludeCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  value = Number(value);
  var suffix = '';

  if (alwaysIncludeCents || Math.round(value) != value) {
    var t = value.toFixed(2).split('.');
    value = Number(t.shift());
    suffix = ".".concat(t.shift());
  }

  value = String(value);
  var t1 = [];

  while (value.length) {
    t1.unshift(value.substr(-3));
    value = value.substring(0, value.length - 3);
  }

  return "$".concat(t1.join(',')).concat(suffix);
}

function formatDateInterval(value) {
  var startingPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var shortDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'M j';
  var longDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'M j, Y';
  if (typeof value == 'string') value = new Date(value);
  if (babelHelpers.instanceof(value, Date)) value = value.getTime();
  var delta = Math.abs(value - startingPoint);
  var future = value > startingPoint;
  var prefix = future ? 'in ' : '';
  var suffix = future ? '' : ' ago';
  if (delta < 60000) return 'now';

  if (delta < 3600000) {
    var minutes = delta / 60000;
    minutes = Math.round(minutes);
    return "".concat(prefix).concat(minutes, " minute").concat(minutes == 1 ? '' : 's').concat(suffix);
  }

  if (delta < 86400000) {
    var hours = delta / 3600000;
    hours = Math.floor(hours);
    return "".concat(prefix).concat(hours, " hour").concat(hours == 1 ? '' : 's').concat(suffix);
  }

  if (delta < 7 * 86400000) {
    var days = delta / 86400000;
    days = Math.floor(days);
    return "".concat(prefix).concat(days, " day").concat(days == 1 ? '' : 's').concat(suffix);
  }

  if (!future && delta < 365 * 86400000) {
    return new Date(value).format(shortDate);
  }

  return new Date(value).format(longDate);
}